<template>
  <el-tooltip class="item"
              effect="dark"
              :placement="isPosition">
    <div slot="content"
         :style="{maxWidth: width + 'px', }">
      <span v-html="tips"></span>
      <!-- <p v-html="tips" :style="{width: width + 'px', }" ></p> -->
    </div>
    <el-button class="inline-btn">
      <span v-if="!tipsFlag">{{tipsLabel}}</span>
      <i v-if="tipsFlag"
         :class="iconClass"
         :style="{position: position, fontSize: fontS + 'px'}"></i>
    </el-button>
  </el-tooltip>
</template>
<script>
export default {
  data() {
    return {
      isShow: false,
      tipData: '<div>22</div>'
    }
  },
  props: {
    // 提示文本
    tips: {
      type: String
    },
    tipsLabel: {
      type: String
    },
    /**
     * 出现位置
     * top/top-start/top-end/bottom/bottom-start/bottom-end/left/left-start/left-end/right/right-start/right-end
     */
    isPosition: {
      type: String,
      default: 'top'
    },
    // 宽度
    width: {
      type: Number,
      default: 100
    },
    position: {
      type: String,
      default: 'inherit'
    },
    fontS: {
      type: Number,
      default: 14
    },
    iconClass: {
      type: String,
      default: 'iconhuice icon-wenhao'
    },
    tipsFlag: {
      type: Boolean,
      default: true

    }
  },
  created() {
    /* 处理文字自动换行 */
    // let m = Math.floor(this.width / 12)
    // let l = this.tips.length
    // let n = Math.ceil(l/m)
    // let d = ''
    // for (let i = 1; i <= n; i++) {
    //   let a = this.tips.substr(m*(i-1),m) + `<br/>`
    //   d += a
    // }
    // this.tipData = d
  }
}
</script>
<style lang="scss" scpoed>
</style>
